<template>
	<div class="pc-main">
		<swiper
			:modules="modules"
			:slides-per-view="1"
			:autoplay="{ delay: 4000 }"
			:loop="true"
			:scrollbar="{ draggable: true }"
			navigation
			effect="fade"
		>
			<swiper-slide>
				<div class="text-box">
					<div class="tit en">
						INNO <br />
						TOWER
					</div>
					<router-link type="button" class="btn en" to="/pc/project/inno">more view</router-link>
				</div>
				<div class="img-wrap project-1"></div>
			</swiper-slide>
			<swiper-slide>
				<div class="text-box">
					<div class="tit en">
						IMFORM <br />
						TOWER
					</div>
					<router-link type="button" class="btn en" to="/pc/project/imporm">more view</router-link>
				</div>
				<div class="img-wrap project-2"></div>
			</swiper-slide>
			<swiper-slide>
				<div class="text-box">
					<div class="tit en">
						FNC <br />
						Entertainment
					</div>
					<router-link type="button" class="btn en" to="/pc/project/fnc">more view</router-link>
				</div>
				<div class="img-wrap project-3"></div>
			</swiper-slide>
			<swiper-slide>
				<div class="text-box">
					<div class="tit en">
						YEON SEUNG <br />
						APPAREL
					</div>
					<router-link type="button" class="btn en" to="/pc/project/yeonseung">more view</router-link>
				</div>
				<div class="img-wrap project-4"></div>
			</swiper-slide>
			<swiper-slide>
				<div class="text-box">
					<div class="tit en">
						ATTERE<br />
						BUILDING
					</div>
					<router-link type="button" class="btn en" to="/pc/project/attere">more view</router-link>
				</div>
				<div class="img-wrap project-5"></div>
			</swiper-slide>
			<swiper-slide>
				<div class="text-box">
					<div class="tit en">
						PCN<br />
						BUILDING
					</div>
					<router-link type="button" class="btn en" to="/pc/project/pcn">more view</router-link>
				</div>
				<div class="img-wrap project-6"></div>
			</swiper-slide>
			<swiper-slide>
				<div class="text-box">
					<div class="tit en">
						EVERHOME<br />
						BUILDING
					</div>
					<router-link type="button" class="btn en" to="/pc/project/everhome">more view</router-link>
				</div>
				<div class="img-wrap project-7"></div>
			</swiper-slide>
			<swiper-slide>
				<div class="text-box">
					<div class="tit en">
						ILHWAN<br />
						BUILDING
					</div>
					<router-link type="button" class="btn en" to="/pc/project/ilhwan">more view</router-link>
				</div>
				<div class="img-wrap project-8"></div>
			</swiper-slide>
			<swiper-slide>
				<div class="text-box">
					<div class="tit en">
						DONGGWANG<br />
						BUILDING
					</div>
					<router-link type="button" class="btn en" to="/pc/project/donggwang">more view</router-link>
				</div>
				<div class="img-wrap project-9"></div>
			</swiper-slide>
			<swiper-slide>
				<div class="text-box">
					<div class="tit en">
						SAMU APARTMANT<br />
						TYPE FACTORIES
					</div>
					<router-link type="button" class="btn en" to="/pc/project/samu">more view</router-link>
				</div>
				<div class="img-wrap project-10"></div>
			</swiper-slide>
			<swiper-slide>
				<div class="text-box">
					<div class="tit en">
						SEONGSU<br />
						PROJECT
					</div>
					<router-link type="button" class="btn en" to="/pc/project/seongui">more view</router-link>
				</div>
				<div class="img-wrap project-11"></div>
			</swiper-slide>
		</swiper>
	</div>
</template>

<script>
import { Autoplay, Navigation, Scrollbar, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
export default {
	name: 'PC_Main',
	components: { Swiper, SwiperSlide },
	computed: {},
	data() {
		return {
			swiper: null,
			modules: [Autoplay, Navigation, Scrollbar, EffectFade],
		};
	},
	created() {},
	methods: {},
};
</script>
